/**
 * Tab-scoped dedupe for the error-feedback prompt. The boundary
 * shows the prompt at most once per browser-tab session — submitting
 * OR dismissing via "Try Again" consumes the slot.
 *
 * Storage: sessionStorage (survives reload, dies with the tab).
 * Fallback: a module-level boolean when sessionStorage is unavailable
 *           (private browsing, blocked storage, embedded contexts).
 */
const KEY = 'clai:error_feedback_prompted';

let inMemoryFlag = false;

function hasWindow(): boolean {
  return typeof window !== 'undefined';
}

export function hasPromptedThisSession(): boolean {
  if (!hasWindow()) return false;
  try {
    if (sessionStorage.getItem(KEY) === '1') return true;
  } catch {
    // Fall through to the in-memory flag.
  }
  return inMemoryFlag;
}

export function markPromptedThisSession(): void {
  inMemoryFlag = true;
  if (!hasWindow()) return;
  try {
    sessionStorage.setItem(KEY, '1');
  } catch {
    // In-memory flag is the source of truth for this tab.
  }
}

/** Test-only: clear both stores so suites don't leak state. */
export function resetPromptedThisSession(): void {
  inMemoryFlag = false;
  if (!hasWindow()) return;
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // No-op.
  }
}
